import { put, call } from 'redux-saga/effects';
import { fetchWithMisToken } from '../../../../utils/fetch-with-mis-token';
import {
    FETCH_PERFORMANCE_CHART_STATS,
    removePerformanceChartStatsRequest,
    setPerformanceChartStats,
    setPerformanceChartSeasonsStats,
    setPerformanceChartStatsRequest,
} from '../actions';

/**
* @typedef {object} FetchPerformanceChartStatsAction
 * @property {object} payload
 * @property {string} payload.type
 * @property {string} payload.playerId
 * @property {string} [payload.seasonId]
*/

/**
* @param {FetchPerformanceChartStatsAction} action - The Redux action.
*/

export function* fetchPerformanceChartStats( action ) {
    const { type, playerId, seasonId } = action.payload;

    yield put( setPerformanceChartStatsRequest( action.payload ) );

    let data = {};

    if (type === 'career') {

        data = yield call(
            fetchWithMisToken,
            `${ PULSE.app.environment.statsPro }/playerCareerSeasonStats/${ playerId }/benchmarked`
        ); 

        yield put( setPerformanceChartStats( data ) );
        
    } else if (type === 'season') {
        
        data = yield call(
            fetchWithMisToken,
            `${ PULSE.app.environment.statsPro }/playerSeasonRoundStats/${ playerId }/benchmarked?seasonId=${ seasonId }`
        );

        if ( data.roundStats ) {
            yield put( setPerformanceChartSeasonsStats( data ) );
        } else {
            // Error handling for when there is no data
            yield put( setPerformanceChartSeasonsStats( { seasonId: seasonId, roundStats: [ { error: 'no data available' } ] } ) );
        }
    }

    yield put( removePerformanceChartStatsRequest( action.payload ) );

    yield put( FETCH_PERFORMANCE_CHART_STATS.success( data ) );
    
}